import { templates }          from "./templates";
import { CustomerConfig }     from "../../src/types";
import { renderTemplate }     from "./render";
import { defaultTranslation } from "./texts";

const config: CustomerConfig = {
    name: {
        en: 'Card Generator',
        de: 'Karten Generator'
    },
    title: {
        en: 'Card Generator',
        de: 'Karten Generator'
    },
    favicon: 'https://www.cws.com/themes/custom/cwsdesign/favicon.png',
    logo: {
        path: require('./assets/cws-workwear-logo.png').default,
        width: 390,
        height: 56,
        margin: 20
    },
    info: {
      en: defaultTranslation,
      de: defaultTranslation
    },
    templates,
    fonts: [
        {
            name: 'Suisse-Bold',
            src: `url(${ require('./assets/fonts/SuisseIntl-Bold.otf').default })`
        },
        {
            name: 'Suisse-Regular',
            src: `url(${ require('./assets/fonts/SuisseIntl-Regular.otf').default })`
        },
        {
            name: 'AlFresco',
            src: `url(${ require('./assets/fonts/AlFresco.ttf').default })`
        }
    ],
    theme: {
        palette: {
            common: { black: "#000", white: "#fff" },
            background: { paper: "#fff", default: "#fafafa" },
            primary: {
                light: "rgba(242, 161, 211, 1)",
                main: "#ffffff",
                dark: "rgba(181, 55, 133, 1)",
                contrastText: "rgba(0, 0, 0, 1)"
            },
            secondary: {
                light: "#ff4081",
                main: "rgba(238, 27, 82, 1)",
                dark: "#c51162",
                contrastText: "rgba(0, 0, 0, 1)"
            },
            error: { light: "#e57373", main: "#f44336", dark: "#d32f2f", contrastText: "#fff" },
            text: {
                primary: "rgba(0, 0, 0, 0.87)",
                secondary: "rgba(0, 0, 0, 0.54)",
                disabled: "rgba(0, 0, 0, 0.38)",
                hint: "rgba(0, 0, 0, 0.38)"
            }
        }
    },
    renderTemplate
}

export default config;